import { ANNOTATIONS_TEMPLATES_URL } from '../constants'

export const goBack = (): void => {
    window.location.href = ANNOTATIONS_TEMPLATES_URL
}
